export default class CampaignGiftQuestionAlternatives {

  constructor() {
      this.id = 0;
      this.description = "";
  }
}